/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialGroupRequest } from './FinancialGroupRequest';
import {
    FinancialGroupRequestFromJSON,
    FinancialGroupRequestFromJSONTyped,
    FinancialGroupRequestToJSON,
    FinancialGroupRequestToJSONTyped,
} from './FinancialGroupRequest';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';

/**
 * 
 * @export
 * @interface CreateUpdatePersonRequest
 */
export interface CreateUpdatePersonRequest {
    /**
     * the unique identifier of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    personId?: string;
    /**
     * the firstname of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    firstname?: string;
    /**
     * the lastname of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    lastname?: string;
    /**
     * the role of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    role?: string;
    /**
     * the gender of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    gender?: string;
    /**
     * the birthdate of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    birthdate?: string;
    /**
     * the title of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    title?: string;
    /**
     * the healthPro type of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    healthProType?: string;
    /**
     * the healthPro number of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    luHealthProNumber?: string;
    /**
     * the nlp preference of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    nlpPref?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof CreateUpdatePersonRequest
     */
    favoritePhone?: PhoneNumber;
    /**
     * the favorite email of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    favoriteEmail?: string;
    /**
     * the favorite language of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    favoriteLanguage?: string;
    /**
     * SSN number for Luxtrust authentication
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    ssnLt?: string;
    /**
     * 
     * @type {FinancialGroupRequest}
     * @memberof CreateUpdatePersonRequest
     */
    financialGroup?: FinancialGroupRequest;
    /**
     * Checks if user have access to the portal
     * @type {boolean}
     * @memberof CreateUpdatePersonRequest
     */
    modulePortalPatient?: boolean;
    /**
     * The BIC of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    bic?: string;
    /**
     * The IBAN of the person
     * @type {string}
     * @memberof CreateUpdatePersonRequest
     */
    iban?: string;
}

/**
 * Check if a given object implements the CreateUpdatePersonRequest interface.
 */
export function instanceOfCreateUpdatePersonRequest(value: object): value is CreateUpdatePersonRequest {
    return true;
}

export function CreateUpdatePersonRequestFromJSON(json: any): CreateUpdatePersonRequest {
    return CreateUpdatePersonRequestFromJSONTyped(json, false);
}

export function CreateUpdatePersonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdatePersonRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'personId': json['personId'] == null ? undefined : json['personId'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
        'role': json['role'] == null ? undefined : json['role'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birthdate': json['birthdate'] == null ? undefined : json['birthdate'],
        'title': json['title'] == null ? undefined : json['title'],
        'healthProType': json['healthProType'] == null ? undefined : json['healthProType'],
        'luHealthProNumber': json['luHealthProNumber'] == null ? undefined : json['luHealthProNumber'],
        'nlpPref': json['nlpPref'] == null ? undefined : json['nlpPref'],
        'favoritePhone': json['favoritePhone'] == null ? undefined : PhoneNumberFromJSON(json['favoritePhone']),
        'favoriteEmail': json['favoriteEmail'] == null ? undefined : json['favoriteEmail'],
        'favoriteLanguage': json['favoriteLanguage'] == null ? undefined : json['favoriteLanguage'],
        'ssnLt': json['ssnLt'] == null ? undefined : json['ssnLt'],
        'financialGroup': json['financialGroup'] == null ? undefined : FinancialGroupRequestFromJSON(json['financialGroup']),
        'modulePortalPatient': json['modulePortalPatient'] == null ? undefined : json['modulePortalPatient'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'iban': json['iban'] == null ? undefined : json['iban'],
    };
}

export function CreateUpdatePersonRequestToJSON(json: any): CreateUpdatePersonRequest {
    return CreateUpdatePersonRequestToJSONTyped(json, false);
}

export function CreateUpdatePersonRequestToJSONTyped(value?: CreateUpdatePersonRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personId': value['personId'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'role': value['role'],
        'gender': value['gender'],
        'birthdate': value['birthdate'],
        'title': value['title'],
        'healthProType': value['healthProType'],
        'luHealthProNumber': value['luHealthProNumber'],
        'nlpPref': value['nlpPref'],
        'favoritePhone': PhoneNumberToJSON(value['favoritePhone']),
        'favoriteEmail': value['favoriteEmail'],
        'favoriteLanguage': value['favoriteLanguage'],
        'ssnLt': value['ssnLt'],
        'financialGroup': FinancialGroupRequestToJSON(value['financialGroup']),
        'modulePortalPatient': value['modulePortalPatient'],
        'bic': value['bic'],
        'iban': value['iban'],
    };
}

